// Shadowing für Metafeld-Definitionen: firmenspezifische Definition ersetzt die
// globale bei gleichem Key (Position des ersten Auftretens bleibt) — spiegelt
// getVisibleMetaColumns im Backend-Service.
export function dedupeMetaFields(fields) {
  const byKey = new Map();
  for (const f of fields) {
    const current = byKey.get(f.key);
    if (!current || (current.firmenId == null && f.firmenId != null)) {
      byKey.set(f.key, f);
    }
  }
  return [...byKey.values()].map((f) => ({ key: f.key, label: f.label }));
}
